module.exports = __webpack_public_path__ + "static/media/MF.55ea3793.png";